/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';

import template from './get-campaign-qr-code-modal.component.html';
import {WINDOW} from '../angular-platform-providers';
import {AppSharedModule} from '../common/app-shared.module';

@Component({
  standalone: true,
  imports: [AppSharedModule],
  selector: 'adn-get-campaign-qr-code-modal',
  template
})
export class GetCampaignQrCodeModalComponent {
  link: string;
  image: string;
  eps: string;
  qrSuccess = false;

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(WINDOW) private readonly window: any
  ) {
  }

  downloadEPS(): void {
    const blob = new this.window.Blob([this.eps], {type: 'application/postscript'});
    const url = URL.createObjectURL(blob);
    const a = this.window.document.createElement('a');
    a.href = url;
    a.download = 'qrcode.eps';
    a.click();
    URL.revokeObjectURL(url);
  }

  downloadPNG(): void {
    const parts = this.image.split(',');
    if (parts.length !== 2) {
      return;
    }
    const byteChars = this.window.atob(parts[1]);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const blob = new this.window.Blob([new Uint8Array(byteNumbers)], {type: 'image/png'});
    const url = URL.createObjectURL(blob);
    const a = this.window.document.createElement('a');
    a.href = url;
    a.download = 'qrcode.png';
    a.click();
    URL.revokeObjectURL(url);
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
